import { createMemoryHistory, createRouter as vuexCreateRouter } from 'vue-router';

//- ROUTES
import shopProductRoutes from '@components/Shop/routes';
import pdpRoutes from '@components/PDP/ssrRoutes';

export function createRouter() {
  return vuexCreateRouter({
    history: createMemoryHistory(),

    routes: [
      ...shopProductRoutes,
      ...pdpRoutes,

      // Catch-all route for ALL server-rendered pages to avoid Vue Router warnings
      // This should be last to catch any route not defined above
      {
        path: '/:pathMatch(.*)*',
        name: 'server-rendered-catch-all',
        component: { render: () => null } // Empty component since content is server-injected
      },
    ],

    scrollBehavior(to, from, savedPosition) {
      if (savedPosition) {
        return savedPosition;
      } else if (to.hash) {
        return {
          el: to.hash,
          top: 10,
          left: 0,
          behavior: 'smooth'
        };
      } else if (to.meta.noScroll) {
        return false;
      } else {
        return {
          left: 0,
          top: 0,
          behavior: 'smooth'
        };
      }
    }
  });
}
